import { apiFetch } from '../utils';
import { PRODUCT_IMAGES_URL } from 'common/env';

export interface Faceplate {
    ImageId: number;
    ImageName: string;
    ImageUrl: string;
}

export const getProductFaceplates = async (productSku: string) => {
    return await apiFetch<Faceplate[]>(PRODUCT_IMAGES_URL, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ productId: productSku }),
    });
};

export const getProductFaceplatesBff = async (productSku: string) => {
    const url = '/c/shop/product/getproductgiftimages';

    return await apiFetch<Faceplate[]>(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ productId: productSku }),
    });
};
